Vue.component('pager', {
    props: ['postData', 'idx'],
    template: '#standardsearch-page-template',
    computed: {
        createformat: function () {
            return moment(this.postData.create).format('DD [de] MMMM [de] YYYY');
        }
    }
})

new Vue({
    el: '#vue-stadardsearch',
    data: {
        posts: [],
        page: 1,
        loading: false,
        finish: false,
        id: null
    },
    beforeMount: function () {
        this.term = this.$el.attributes['data-match-term'].value;
        this.from = this.$el.attributes['data-match-from'].value;
        this.sectionId = this.$el.attributes['data-match-section'].value;
        this.tagId = this.$el.attributes['data-match-tag'].value;
        this.totalPosts = parseInt(this.$el.attributes['data-match-total'].value);
        this.itemsPerPage = parseInt(this.$el.attributes['data-match-pagesize'].value);
        //this.totalPages = this.totalPosts / this.itemsPerPage;

    },
    mounted: function () {
        epicaAddEventClick('#vue-stadardsearch');
    },
    updated: function () {
        lazyLoadInit();
        onResize();
        epicaAddEventClick('#vue-stadardsearch');
    },
    methods: {
        getPosts: function (pageNumber) {
            this.page = pageNumber;
            this.loading = true;
            var params = {
                Term: this.term,
                Page: this.page,
                PageSize: this.itemsPerPage
            }
            if (this.from && this.from != "") {
                params.From = this.from;
            }
            if (this.sectionId && this.sectionId != "") {
                params.SectionId = this.sectionId;
            }
            if (this.tagId && this.tagId != "") {
                params.TagId = this.TagId;
            }
            var paramsqs = jQuery.param(params);

            this.$http.get('/api/standard?' + paramsqs).then(function (response) {
                $('html,body').scrollTop(0);
                this.posts = response.body;
                this.loading = false;
                this.finish = response.body.length == 0;

            }, function (response) {

            });
        },
        dateFormat: function (date) {
            return moment(date).format('dd [de] MMMM [de] yyyy');
        }
        //setPage: function (pageNumber) {
        //    this.page = pageNumber
        //}
    },
    computed: {
        totalPages: function () {
            return Math.ceil(this.totalPosts / this.itemsPerPage)
        },
        selectedClass: function (pageNumber) {
            if (pageNumber == this.page) {
                return 'selected';
            } else {
                return '';
            }
        }
    },

});